var map = {
  "./cs.json": [
    "QuU",
    [
      "u7i"
    ]
  ],
  "./en.json": [
    "HM",
    [
      "xu"
    ]
  ],
  "./pl.json": [
    "DB",
    [
      "d1"
    ]
  ],
  "./ru.json": [
    "SiV",
    [
      "sa"
    ]
  ],
  "./tr.json": [
    "UOF",
    [
      "ua"
    ]
  ],
  "./ja.json": [
    "lg",
    [
      "f1"
    ]
  ],
  "./zh.json": [
    "Y0",
    [
      "mxw"
    ]
  ],
  "./pt-br.json": [
    "hI",
    [
      "vgd"
    ]
  ],
  "./de.json": [
    "Q4",
    [
      "ev"
    ]
  ],
  "./es.json": [
    "il",
    [
      "o5"
    ]
  ],
  "./fr.json": [
    "aF",
    [
      "8x"
    ]
  ],
  "./it.json": [
    "Q1k",
    [
      "ma3"
    ]
  ],
  "./ko.json": [
    "K67",
    [
      "cy"
    ]
  ],
  "./pt.json": [
    "eR",
    [
      "ou"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "yQ";
module.exports = __rspack_async_context;
